<template lang="pug">
.contentContainer
    h1.TitleU {{name}}
    p 
    .HTMLContainer(v-html="body[year]")
</template>

<script>

export default {
    props: ['year'],
    data () {
        return {
            name: "CALL FOR PAPERS",
            body: {
                2024: `<p>A surge in the popularity of VR/AR technology has given rise to a plethora of applications to captivate new users; however, further advances in VR/AR realism will require the integration of novel input modalities and multiple realistic sensations. This workshop will provide a platform to facilitate collaborations among researchers in UbiComp and VR/AR fields in exploring novel approaches to making this vision a reality.</p>

                <h1>Topics</h1>

                <p>Papers may include some of the topics, but are not limited to:</p>

                <ul>
                    <li>2D/3D and volumetric display and projection technology</li>
                    <li>Immersive analytics and visualization</li>
                    <li>Modeling and simulation</li>
                    <li>Multimodal capturing and reconstruction</li>
                    <li>Scene description and management issues</li>
                    <li>Storytelling</li>
                    <li>Tracking and sensing</li>
                    <li>Audio interfaces, sound rendering, spatialized audio, auditory perception and psychoacoustics</li>
                    <li>Embodied agents, virtual humans and (self-)avatars</li>
                    <li>Haptic and tactile interfaces, wearable haptics, passive haptics, pseudo haptics, other touch-based UI</li>
                    <li>Mediated and diminished reality</li>
                    <li>Multimodal input and output</li>
                    <li>Multisensory rendering, registration, and synchronization</li>
                    <li>Perception and cognition</li>
                    <li>Presence, body ownership, and agency</li>
                    <li>Teleoperation and telepresence</li>
                    <li>3D user interaction</li>
                    <li>3D UI metaphors</li>
                    <li>Collaborative interactions</li>
                    <li>Ethical issues</li>
                    <li>Human factors and ergonomics</li>
                    <li>Input devices</li>
                    <li>Locomotion and navigation</li>
                    <li>Multimodal/cross-modal interaction and perception</li>
                    <li>Non-fatiguing 3D UIs</li>
                    <li>Non-visual interfaces (such as olfactory)</li>
                    <li>Touch, tangible and gesture interfaces</li>
                    <li>Usage research, evaluation methods and empirical studies</li>
                    <li>Domain-specific VR/AR/MR/XR applications.</li>
                    <li>Design process, platform/tools, or libraries used to incorporate input modalities or sensations for VR/AR interactions or studying their use</li>
                </ul>

                <h1>Important Dates</h1>

                <p>Paper submission: 23:59 (AoE), <s>June 7, 2024</s> June 14, 2024 <span style="color:#e74c3c">(extended)</span></p>

                <p>Paper notification: 23:59 (AoE), <s>June 28, 2024</s> July 5, 2024 <span style="color:#e74c3c">(extended)</span></p>

                <p>Camera-ready: 23:59 (AoE), July 26, 2024</p>

                <p>Workshop: October 6th, 2024</p>

                <h1>Best Paper Award</h1>

                <p>The Best Paper Award is given to the best paper presented at the MIMSVAI 2024 workshop, to acknowledge and encourage excellence in research. The awardee will be presented with a certificate at the workshop.</p>

                <h2>Submission Guidelines</h2>

                <p>Submissions should be made electronically through the&nbsp;<a href="https://new.precisionconference.com/" target="blank">Online Submission System (PCS)</a><strong>. </strong>Please select &ldquo;SIGCHI&rdquo; as Society, &ldquo;Ubicomp/ISWC 2024&rdquo; as Conference/Journal, and &ldquo;UbiComp/ISWC 2024 Workshop MIMSVAI&rdquo; as the track on the submission page.<br />
                <br />
                <strong><span style="color:#e74c3c">All papers need to be anonymized</span>.</strong> Please submit papers with a maximum length of 5 pages (4-page + 1 references) in ACM SIGCHI sigconf template with 2 columns (<a href="https://www.acm.org/publications/proceedings-template">https://www.acm.org/publications/proceedings-template</a>). Please contact us (<a href="mailto:ubicomp.mimsvai@gmail.com">ubicomp.mimsvai@gmail.com</a>) if you have any problems when preparing your submissions.</p>

                <p>At least one author of each accepted paper needs to register for the conference and the workshop itself. During the workshop, each paper will be presented briefly by one of the authors. And, the Best Paper Award will be given to the best paper presented at the MIMSVAI 2024 workshop, to acknowledge and encourage excellence in research. The awardee will be presented with a certificate at the workshop.</p>

                <p>The accepted papers will be published in the UbiComp/ISWC Adjunct Proceedings, which will be included in the ACM Digital Library as part of the UbiComp conference supplemental proceedings.</p>
                `,
                2023: `<p>The increasing popularity of VR/AR technology has led to the emergence of numerous VR/AR applications that appeal to new users. To enhance the level of perceived realism, alternative input modalities and multiple realistic sensations need to be developed and integrated coherently for users to interact with these technologies. Although these developments have the potential to create more immersive VR/AR experiences, the lack of robust and intuitive interaction interfaces and realistic sensations limits the level of users' acceptance in various application areas. This workshop aims to address the challenges and opportunities of designing a higher coherence between different input modalities and sensations to offer more engaging VR/AR experiences. It provides a platform for researchers from both UbiComp and VR/AR fields to collaborate and explore alternative input modalities and sensations for VR/AR interactions.</p>

                <h1>Topics</h1>

                <p>Papers may include some of the topics, but are not limited to:</p>

                <ul>
                    <li>2D/3D and volumetric display and projection technology</li>
                    <li>Immersive analytics and visualization</li>
                    <li>Modeling and simulation</li>
                    <li>Multimodal capturing and reconstruction</li>
                    <li>Scene description and management issues</li>
                    <li>Storytelling</li>
                    <li>Tracking and sensing</li>
                    <li>Audio interfaces, sound rendering, spatialized audio, auditory perception and psychoacoustics</li>
                    <li>Embodied agents, virtual humans and (self-)avatars</li>
                    <li>Haptic and tactile interfaces, wearable haptics, passive haptics, pseudo haptics, other touch-based UI</li>
                    <li>Mediated and diminished reality</li>
                    <li>Multimodal input and output</li>
                    <li>Multisensory rendering, registration, and synchronization</li>
                    <li>Perception and cognition</li>
                    <li>Presence, body ownership, and agency</li>
                    <li>Teleoperation and telepresence</li>
                    <li>3D user interaction</li>
                    <li>3D UI metaphors</li>
                    <li>Collaborative interactions</li>
                    <li>Ethical issues</li>
                    <li>Human factors and ergonomics</li>
                    <li>Input devices</li>
                    <li>Locomotion and navigation</li>
                    <li>Multimodal/cross-modal interaction and perception</li>
                    <li>Non-fatiguing 3D UIs</li>
                    <li>Non-visual interfaces (such as olfactory)</li>
                    <li>Touch, tangible and gesture interfaces</li>
                    <li>Usage research, evaluation methods and empirical studies</li>
                    <li>Domain-specific VR/AR applications.</li>
                    <li>Design process, platform/tools, or libraries used to incorporate input modalities or sensations for VR/AR interactions or studying their use</li>
                </ul>

                <h1>Important Dates</h1>

                <p>Paper submission: 23:59 (AoE), <s>June 2, 2023</s> <s>June 9, 2023</s> June 16, 2023 <span style="color:#e74c3c">(extended and final)</span></p>

                <p>Paper notification: 23:59 (AoE), <s>June 30, 2023</s> July 8, 2023 <span style="color:#e74c3c">(extended)</span></p>

                <p>Camera-ready: 23:59 (AoE), July 31, 2023</p>

                <p>Workshop: October 9th, 2023</p>

                <h1>Best Paper Award</h1>

                <p>The Best Paper Award is given to the best paper presented at the MIMSVAI 2023 workshop, to acknowledge and encourage excellence in research. The awardee will be presented with a certificate at the workshop.</p>

                <h2>Submission Guidelines</h2>

                <p>Submissions should be made electronically through the&nbsp;<a href="https://new.precisionconference.com/" target="blank">Online Submission System (PCS)</a><strong>. </strong>Please select &ldquo;SIGCHI&rdquo; as Society, &ldquo;Ubicomp/ISWC 2023&rdquo; as Conference/Journal, and &ldquo;UbiComp/ISWC 2023 Workshop MIMSVAI&rdquo; as the track on the submission page.<br />
                <br />
                <strong><span style="color:#e74c3c">All papers need to be anonymized</span>.</strong> Please submit papers with a maximum length of 5 pages (4-page + 1 references) in ACM SIGCHI sigconf template with 2 columns (<a href="https://www.acm.org/publications/proceedings-template">https://www.acm.org/publications/proceedings-template</a>). Please contact us (<a href="mailto:ubicomp.mimsvai@gmail.com">ubicomp.mimsvai@gmail.com</a>) if you have any problems when preparing your submissions.</p>

                <p>At least one author of each accepted paper needs to register for the conference and the workshop itself. During the workshop, each paper will be presented briefly by one of the authors. And, the Best Paper Award will be given to the best paper presented at the MIMSVAI 2023 workshop, to acknowledge and encourage excellence in research. The awardee will be presented with a certificate at the workshop.</p>

                <p>The accepted papers will be published in the UbiComp/ISWC Adjunct Proceedings, which will be included in the ACM Digital Library as part of the UbiComp conference supplemental proceedings.</p>
                `,
                2022: `<p>With the advance of VR/AR technology, more and more VR/AR applications are emerging and have been popular among new users. Interacting with virtual reality and augmented reality technologies will require the development of alternative input modalities as well as coherent integration of multiple realistic sensations to increase the level of perceived realism. These developments will create a more immersive VR/AR experience. However, a lack of robust and intuitive interaction interfaces and realistic sensations hinders users&#39; experience for achieving a fascinating acceptance in various application areas of VR/AR interactions. This workshop discusses the challenges and applications of designing a higher coherence between different input modalities and sensations to offer more engaging VR/AR experiences, which can create opportunities for the researchers from both UbiComp and VR/AR fields to jointly discuss and brainstorm alternative input modalities and sensations for VR/AR interactions.</p>

                <h1>Topics</h1>

                <p>Papers may include, but not be limited to, topics such as:</p>

                <ul>
                    <li>2D/3D and volumetric display and projection technology</li>
                    <li>Immersive analytics and visualization</li>
                    <li>Modeling and simulation</li>
                    <li>Multimodal capturing and reconstruction</li>
                    <li>Scene description and management issues</li>
                    <li>Storytelling</li>
                    <li>Tracking and sensing</li>
                    <li>Audio interfaces, sound rendering, spatialized audio, auditory perception and psychoacoustics</li>
                    <li>Embodied agents, virtual humans and (self-)avatars</li>
                    <li>Haptic and tactile interfaces, wearable haptics, passive haptics, pseudo haptics, other touch-based UI</li>
                    <li>Mediated and diminished reality</li>
                    <li>Multimodal input and output</li>
                    <li>Multisensory rendering, registration, and synchronization</li>
                    <li>Perception and cognition</li>
                    <li>Presence, body ownership, and agency</li>
                    <li>Teleoperation and telepresence</li>
                    <li>3D user interaction</li>
                    <li>3D UI metaphors</li>
                    <li>Collaborative interactions</li>
                    <li>Ethical issues</li>
                    <li>Human factors and ergonomics</li>
                    <li>Input devices</li>
                    <li>Locomotion and navigation</li>
                    <li>Multimodal/cross-modal interaction and perception</li>
                    <li>Non-fatiguing 3D UIs</li>
                    <li>Non-visual interfaces (such as olfactory)</li>
                    <li>Touch, tangible and gesture interfaces</li>
                    <li>Usage research, evaluation methods and empirical studies</li>
                    <li>Domain-specific VR/AR applications.</li>
                    <li>Design process, platform/tools, or libraries used to incorporate input modalities or sensations for VR/AR interactions or studying their use</li>
                </ul>

                <h1>Important Dates</h1>

                <p>Paper submission: 23:59 (AoE), <s>July 29, 2022</s> August 5, 2022&nbsp;</p>

                <p>Paper notification: 23:59 (AoE), <s>August 21, 2022</s> August 26, 2022</p>

                <p>Camera-ready: 23:59 (AoE), September 2, 2022</p>

                <p>Workshop: September 11, 2022</p>

                <h1>Best Paper Award</h1>

                <p>The Best Paper Award is given to the best paper presented at the MIMSVAI 2022 workshop, to acknowledge and encourage excellence in research. The awardee will be presented with a certificate at the workshop.</p>

                <h2>Submission Guidelines</h2>

                <p>Submissions should be made electronically through the&nbsp;<a href="https://new.precisionconference.com/" target="blank">Online Submission System (PCS)</a><strong>. </strong>Please select &ldquo;SIGCHI&rdquo; as Society, &ldquo;Ubicomp/ISWC 2022&rdquo; as Conference/Journal, and &ldquo;UbiComp/ISWC 2022 Workshop MIMSVAI&rdquo; as the track on the submission page.<br />
                <br />
                <strong><span style="color:#e74c3c">All papers need to be anonymized</span>.</strong> Please submit papers with a maximum length of 5 pages (4-page + 1 references) in ACM SIGCHI sigconf template with 2 columns (<a href="https://www.acm.org/publications/proceedings-template">https://www.acm.org/publications/proceedings-template</a>). Please contact us (<a href="mailto:ubicomp.mimsvai@gmail.com">ubicomp.mimsvai@gmail.com</a>) if you have any problems when preparing your submissions.</p>

                <p>At least one author of each accepted paper needs to register for the conference and the workshop itself. During the workshop, each paper will be presented briefly by one of the authors. And, the Best Paper Award will be given to the best paper presented at the MIMSVAI 2022 workshop, to acknowledge and encourage excellence in research. The awardee will be presented with a certificate at the workshop.</p>

                <p>The accepted papers will be published in the UbiComp/ISWC Adjunct Proceedings, which will be included in the ACM Digital Library as part of the UbiComp conference supplemental proceedings.</p>
                `,
                2021: `<p dir="ltr">With the advance of VR/AR technology, more and more VR/AR&nbsp;applications are emerging and have been popular among new users.&nbsp;To facilitate user interaction with the systems, multi-modal input&nbsp;modalities are required. Furthermore, coherent integration of&nbsp;multiple realistic sensations can increase the level of realism, and&nbsp;therefore creates a truly immersive VR/AR experience. However,&nbsp;a lack of robust and intuitive interaction interfaces and realistic&nbsp;sensations hinders users&rsquo; experience for achieving a fascinating&nbsp;acceptance in various application areas of VR/AR interactions. This&nbsp;workshop discusses the challenges and applications of designing a&nbsp;higher coherence between the different input modalities and sensations&nbsp;to provide more engaging VR/AR experiences by leveraging&nbsp;the advances of both VR/AR software and hardware to improve user experience.</p>

                <h1 dir="ltr">Topics</h1>

                <p>Papers may include, but not be limited to, topics such as:</p>

                <ul>
                    <li>2D/3D and volumetric display and projection technology</li>
                    <li>Immersive analytics and visualization</li>
                    <li>Modeling and simulation</li>
                    <li>Multimodal capturing and reconstruction</li>
                    <li>Scene description and management issues</li>
                    <li>Storytelling</li>
                    <li>Tracking and sensing</li>
                    <li>Audio interfaces, sound rendering, spatialized audio, auditory perception and psychoacoustics</li>
                    <li>Embodied agents, virtual humans and (self-)avatars</li>
                    <li>Haptic and tactile interfaces, wearable haptics, passive haptics, pseudo haptics, other touch-based UI</li>
                    <li>Mediated and diminished reality</li>
                    <li>Multimodal input and output</li>
                    <li>Multisensory rendering, registration, and synchronization</li>
                    <li>Perception and cognition</li>
                    <li>Presence, body ownership, and agency</li>
                    <li>Teleoperation and telepresence</li>
                    <li>3D user interaction</li>
                    <li>3D UI metaphors</li>
                    <li>Collaborative interactions</li>
                    <li>Ethical issues</li>
                    <li>Human factors and ergonomics</li>
                    <li>Input devices</li>
                    <li>Locomotion and navigation</li>
                    <li>Multimodal/cross-modal interaction and perception</li>
                    <li>Non-fatiguing 3D UIs</li>
                    <li>Non-visual interfaces (such as olfactory)</li>
                    <li>Touch, tangible and gesture interfaces</li>
                    <li>Usage research, evaluation methods and empirical studies</li>
                    <li>Domain-specific VR/AR applications.</li>
                    <li>Design process, platform/tools, or libraries used to incorporate input modalities or sensations for VR/AR interactions or studying their use</li>
                </ul>

                <h1 dir="ltr">Important Dates</h1>

                <p dir="ltr">Paper submission: 23:59 (AoE), <s>June 15, 2021&nbsp;June 22, 2021</s> June 30, 2021 <span style="color:#e74c3c">(extended and final)</span></p>

                <p dir="ltr">Paper notification: 23:59 (AoE), July 15, 2021</p>

                <p dir="ltr">Camera-ready: 23:59 (AoE), <s>July 31, 2021 Aug. 6, 2021</s> Aug. 10, 2021<span style="color:#e74c3c"> (extended)</span></p>

                <p dir="ltr">Workshop: September 26, 2021</p>

                <h1 dir="ltr">Best Paper Award</h1>

                <p dir="ltr">The Best Paper Award is given to the best paper presented at the MIMSVAI 2021 workshop, to acknowledge and encourage excellence in research. The awardee will be presented with a certificate at the workshop.</p>

                <h2 dir="ltr">Submission Guidelines</h2>

                <p dir="ltr">Please submit your paper via this EasyChair link:<br />
                <a href="https://easychair.org/conferences/?conf=mimsvai2021">https://easychair.org/conferences/?conf=mimsvai2021</a></p>

                <p dir="ltr"><strong>All papers need to be anonymized.</strong> Please submit papers with a maximum length of 5 pages (4-page + 1 references) in ACM SIGCHI Master Article template with 2 columns (<a href="https://ubicomp.org/ubicomp2022/cfp/template-information/" target="_blank"></a>). Please contact us (<a href="mailto:ubicomp.mimsvai@gmail.com">ubicomp.mimsvai@gmail.com</a>) if you have any problems when preparing your submissions.</p>

                <p dir="ltr">At least one author of each accepted paper needs to register for the conference and the workshop itself. During the workshop, each paper will be presented briefly by one of the authors. And, the Best Paper Award will be given to the best paper presented at the MIMSVAI 2021 workshop, to acknowledge and encourage excellence in research. The awardee will be presented with a certificate at the workshop.</p>

                <p dir="ltr">The accepted papers will be published in the UbiComp/ISWC Adjunct Proceedings, which will be included in the ACM Digital Library as part of the UbiComp conference supplemental proceedings.</p>
                `
            }
        }
    },
    methods: {

    }
}
</script>

<style lang="sass" scoped>
@import "@/style/value.sass"

</style>



// WEBPACK FOOTER //
// src/components/mainPage/Paper.vue